import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { countryModel } from 'entities/country';
import { pharmaceuticalCompanyModel } from 'entities/pharmaceutical-company';
import { userModel } from 'entities/user';
import { VaccineDialog, vaccineModel } from 'entities/vaccine';

type Props = {
  disabled?: boolean;
  isPets?: boolean;
  onSubmit: Function;
  isSuccess: boolean;
  isLoading: boolean;
};

export const CreateVaccine = ({ disabled = false, isPets = false, onSubmit, isSuccess, isLoading }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { vaccineList } = vaccineModel.useVaccineList();
  const { data: countriesData } = countryModel.useAllCountries();
  const { data: pharmaCompaniesData } = pharmaceuticalCompanyModel.useLightPharmaCompanies(isOpen);
  const { data } = userModel.useUser();

  useEffect(() => {
    if (isSuccess) setIsOpen(false);
  }, [isSuccess]);

  return (
    <>
      <Button variant="contained" onClick={() => setIsOpen(true)} sx={{ alignSelf: 'end' }} disabled={disabled}>
        Add vaccine
      </Button>
      <VaccineDialog
        title="Add vaccine"
        isOpen={isOpen}
        isPets={isPets}
        vaccineList={vaccineList}
        userRole={data?.role}
        onClose={() => setIsOpen(false)}
        onSubmit={onSubmit}
        isLoading={isLoading}
        countries={countriesData?.data ?? []}
        pharmaCompanies={pharmaCompaniesData?.data ?? []}
      />
    </>
  );
};
